import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ActionBarModule } from './components/action-bar/action-bar.module';
import { ContentExpanderComponent } from './content-expander.component';

@NgModule({
  declarations: [ContentExpanderComponent],
  imports: [CommonModule, ActionBarModule],
  exports: [ContentExpanderComponent]
})
export class ContentExpanderModule {}
